import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("ORACLE crash:", error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight:"100vh", background:"#070710", display:"flex", alignItems:"center", justifyContent:"center", padding:"24px", fontFamily:"'DM Mono',monospace" }}>
        <div style={{ maxWidth:"560px", width:"100%", background:"#0b0b1c", border:"1px solid rgba(255,80,80,.25)", borderRadius:"16px", padding:"32px" }}>
          <p style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:"28px", letterSpacing:".15em", color:"rgba(255,80,80,.8)", marginBottom:"12px" }}>ORACLE CRASHED</p>
          <p style={{ fontSize:"11px", color:"rgba(255,255,255,.35)", lineHeight:"1.7", marginBottom:"20px" }}>Open DevTools → Console to see the full error. Copy it and send to the developer.</p>
          <pre style={{ fontSize:"10px", color:"rgba(255,160,80,.7)", background:"rgba(255,255,255,.03)", border:"1px solid rgba(255,255,255,.06)", borderRadius:"8px", padding:"14px", overflowX:"auto", whiteSpace:"pre-wrap", wordBreak:"break-all", lineHeight:"1.6", marginBottom:"20px" }}>
            {this.state.error?.message || String(this.state.error)}
            {"\n\n"}
            {this.state.error?.stack?.split("\n").slice(0,6).join("\n")}
          </pre>
          <button onClick={() => window.location.reload()} style={{ padding:"10px 24px", borderRadius:"8px", border:"none", background:"#E8FF47", color:"#070710", fontFamily:"'DM Mono',monospace", fontSize:"10px", letterSpacing:".1em", textTransform:"uppercase", cursor:"pointer", fontWeight:"700" }}>
            Reload ORACLE
          </button>
        </div>
      </div>
    );
  }
}
